import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Recruiter } from '@app/model/recruiter';
import { environment } from '@environments/environment';
import { UserSerializer } from '@app/model/serializer/user-serialize';


@Injectable({ providedIn: 'root' })
export class RecruiterServiceGet extends ApiService<Recruiter> {
  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'user/role/Recruiter',
      new UserSerializer());
  }
}
